import { useState } from 'react';
import _ from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import { getIsSaving, getLastSavedPpsiId } from '../selectors';
import { createPpsiFromGlobalNir } from '../actions';

const useCreatePpsiFromGlobalNir = () => {
  const [hasSaved, setHasSaved] = useState(false);
  const dispatch = useDispatch();
  const isSaving = useSelector(getIsSaving);
  const createdPpsiId = useSelector(getLastSavedPpsiId);

  const onCreatePpsiFromGlobal = (
    data,
    callback,
    globalPiaArticleNumber = null
  ) => {
    const { formulaCode, modifyDate: hash, ...rest } = data.dish;
    const ppsi = _.omit(data, ['dish', 'utensils', 'ingredientEntryIds']);

    const productAreaData = {
      piaProductArea: rest.piaProductArea,
      piaProductAreaName: rest.piaProductAreaName,
      piaRangeArea: rest.piaRangeArea,
      piaRangeAreaName: rest.piaRangeAreaName
    };

    if (globalPiaArticleNumber) {
      dispatch(
        createPpsiFromGlobalNir(
          formulaCode,
          ppsi,
          productAreaData,
          globalPiaArticleNumber,
          callback
        )
      );
      setHasSaved(true);
    }
  };

  return [onCreatePpsiFromGlobal, isSaving, hasSaved ? createdPpsiId : null];
};

export default useCreatePpsiFromGlobalNir;
